import { lazy } from 'react';

export const ADD_GUSTO_EMPLOYEES = 'ADD_GUSTO_EMPLOYEES';
export const EXPORT_GUSTO_DIALOG = 'EXPORT_GUSTO_DIALOG';
export const MATCH_GUSTO_EMPLOYEES = 'MATCH_GUSTO_EMPLOYEES';
export const POSITION_HOUR_DIALOG = 'POSITION_HOUR_DIALOG';
export const REAUTHORIZE_DIALOG = 'REAUTHORIZE_DIALOG';

const dialogs = {
  [ADD_GUSTO_EMPLOYEES]: lazy(() => import('./AddEmployees')),
  [EXPORT_GUSTO_DIALOG]: lazy(() => import('./ExportGusto')),
  [MATCH_GUSTO_EMPLOYEES]: lazy(() => import('./MatchEmployees')),
  [REAUTHORIZE_DIALOG]: lazy(() => import('./Reauthorize')),
};

export default dialogs;
